var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { persistReducer } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';
import { persistFilters } from './persistFilters';
var whitelist = [];
export var persistReducers = function (reducers) {
    return persistReducer({
        key: 'key/storage',
        storage: storage,
        whitelist: whitelist,
        stateReconciler: autoMergeLevel2,
        transforms: __spreadArray([], persistFilters, true),
    }, reducers);
};
